import React, { useState, useEffect } from 'react';
import AwesomeDebouncePromise from 'awesome-debounce-promise';

import Button from '../Button';
import { Search } from '../../static';

import './styles.scss';

const SearchForm = ({ 
	onSubmit, 
	onChange, 
	type = 'all',
	placeholder = "Search patient",
	handleClearValue = false
}) => {
	const [value, setValue] = useState('');

	const handleChange = ({target}) => {
		if(type === 'all') {
			setValue(target.value);
		} else {
			setValue(target.value);
			handleTextChange(target.value);
		}
	};
	
	const handleSubmit = (event) => {
		event.preventDefault();
		onSubmit && onSubmit(value);
		setValue('');
	};

	let searchebounced = AwesomeDebouncePromise((value) => value, 1000);
	let handleTextChange = async text => {
		const result = await searchebounced(text);
		onChange && onChange(result);
	};

	useEffect(() => {
		if(handleClearValue) {
			setValue('');
		}
	},[handleClearValue])

	return (
		<form className="search-form" onSubmit={handleSubmit}>
			<input 
				type="text" 
				value={value}
				placeholder={placeholder} 
				onChange={handleChange}
			/>
			<div className="search-form__btn">
				<Button leftIcon={<Search />} isLight/>
			</div>
		</form>
	);
};

export default SearchForm;
